import React from 'react';
import { cutTimestamp } from './statementCutTimeline';

const dateLabel = value => new Date(cutTimestamp(value)).toLocaleString('es-AR', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  timeZone: 'America/Argentina/Buenos_Aires', hour12: false,
});
const label = cut => cut.origen === 'drive_tudemune' ? 'Auditado contra el Drive de TUDEMUNE'
  : cut.silencioso ? 'Auditado en silencio' : 'Estado de cuenta enviado';

export default function StatementCutRow({ cuts }) {
  if (!cuts.length) return null;
  const hasSent = cuts.some(cut => !cut.silencioso && cut.origen !== 'drive_tudemune');
  return (
    <tr className="border-0" data-testid="statement-cut-group">
      <td colSpan={12} className={`px-4 py-2 border-y border-l-4 ${hasSent ? 'bg-blue-50 border-y-blue-200 border-l-blue-500' : 'bg-emerald-50 border-y-emerald-200 border-l-emerald-500'}`}>
        {cuts.length === 1 ? (
          <p className={`text-sm font-semibold ${hasSent ? 'text-blue-800' : 'text-emerald-800'}`}>
            {label(cuts[0])} · {dateLabel(cuts[0].fecha)}
          </p>
        ) : (
          <details className={`text-sm ${hasSent ? 'text-blue-800' : 'text-emerald-800'}`}>
            <summary className="cursor-pointer py-1 font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500">
              {cuts.length} avisos de estado de cuenta / auditoría · {dateLabel(cuts[0].fecha)} · Ver detalle
            </summary>
            <ul className="mt-2 max-h-48 overflow-y-auto space-y-2 border-l-2 border-slate-200 pl-3" aria-label="Detalle de avisos">
              {cuts.map(cut => <li key={cut.key} className={cut.silencioso || cut.origen === 'drive_tudemune' ? 'text-emerald-800 font-medium' : 'text-blue-800 font-semibold'}>
                {label(cut)} · {dateLabel(cut.fecha)}
              </li>)}
            </ul>
          </details>
        )}
      </td>
    </tr>
  );
}
